import {EMigrationStatus} from './MigrationTab/definitions';
import {EPaymentCorrectionType} from './PaymentsTab';
import {ESubscriptionActionType, ESubscriptionCountryType} from './SmsChannelTab/definitions';
import {ECorrectionsTab, EMigrationTab} from './definitions';

export default {
  tabs: {
    [ECorrectionsTab.PAYMENTS]: '[en] Списания и оплаты',
    [ECorrectionsTab.LICENSES]: 'Licenses',
    [ECorrectionsTab.SMS_CHANNEL]: 'SMS profiles',
    [ECorrectionsTab.MIGRATION]: 'Migration',
    [ECorrectionsTab.TARIFFS]: 'Tariff changes',
  },
  payments: {
    selectType: '[en] Выберите тип операции',
    notFound: '[en] Операция не найдена',
    searchResults: '[en] Результаты поиска',
    type: {
      [EPaymentCorrectionType.STORNO]: '[en] Сторнировать операцию',
      [EPaymentCorrectionType.CANCEL_STORNO]: '[en] Отменить сторно',
      [EPaymentCorrectionType.UPDATE_SUM]: '[en] Изменить сумму операции',
      [EPaymentCorrectionType.CARD_PAYMENTS]: '[en] Платежи по картам',
    },
    storno: {
      enterEventId: '[en] Укажите ID операции',
      enterSum: '[en] Введите сумму',
      invalidEventType: '[en] Изменить сумму по данному типу операции невозможно',
      duplicateSumError: '[en] Новая сумма должна отличаться от суммы транзакции',
      companyName: 'Company name',
      paymentType: 'Payment type',
      licensePayment: 'License payment',
      amount: '[en] Сумма списания с НДС',
      date: '[en] Дата транзакции',
      currency: 'Currency',
      isSearchCorrectMessage: '[en] Обязательно убедитесь в корректности запроса по таблицам',
      billedEvent: 'Billed event',
      debtTransaction: 'Debt transaction',
      transaction: 'Transaction',
      id: 'ID',
      originalEventId: 'Original event ID',
      originalEventType: 'Original event Type',
      confirmation: 'Confirmation',
      createdAt: 'Created at',
      eventId: 'Event ID',
      tenantId: '[en] ID компании',
      reason: 'Reason',
      reasonCode: 'Reason code',
      balanceId: 'Balance ID',
      openingBalance: 'Opening balance',
      state: 'State',
      updated: 'Updated',
      search: 'Search',
      comment: '[en] Комментарий к корректировке',
      button: {
        [EPaymentCorrectionType.STORNO]: '[en] Сторнировать',
        [EPaymentCorrectionType.CANCEL_STORNO]: '[en] Отменить сторно',
        [EPaymentCorrectionType.UPDATE_SUM]: '[en] Изменить сумму',
      },
      confirmModal: {
        title: {
          [EPaymentCorrectionType.STORNO]: '[en] Уверены? Мы отменяем списание',
          [EPaymentCorrectionType.CANCEL_STORNO]: '[en] Уверены? Мы отменяем сторно',
          [EPaymentCorrectionType.UPDATE_SUM]: '[en] Уверены? Мы меняем сумму транзакции',
        },
        message: '[en] Если это ошибочная операция, то исправить это будет невозможно',
        subtitle: '[en] Проверьте данные:',
        button: '[en] Да, продолжить',
      },
      successModal: {
        title: '[en] Все хорошо!',
        message: '[en] Запрос принят к исполнению',
      },
    },
    card: {
      search: '[en] Поиск платежа',
      selectDate: '[en] Выберите дату',
      selectUser: '[en] Введите ID пользователя',
      table: {
        date: '[en] Дата',
        tenant: '[en] Тенанта',
        paymentId: '[en] ID платежа',
        sum: '[en] Сумма',
        status: '[en] Статус платежа',
      },
      refundButton: '[en] Сделать полный возврат',
      partialRefundButton: '[en] Частичный возврат',
      refundModal: {
        title: '[en] Сделать полный возврат платежа на карту?',
        partialTitle: '[en] Сделать частичный возврат платежа на карту?',
        check: '[en] Проверьте данные:',
        sum: '[en] Введите сумму',
        initialSum: '[en] Исходная сумма платежа',
        availableRefundSum: '[en] Остаток платежа после частичных возвратов',
        balanceError: '[en] На балансе тенанты недостаточная сумма для возврата',
        submitButton: '[en] Сделать возврат',
      },
      successRefundModal: {
        title: '[en] Все хорошо!',
        subtitle: '[en] Возврат платежа инициирован',
      },
    },
  },
  licenses: {
    channelType: 'Channel type',
    licenseId: 'License ID',
    month: 'Month',
    year: 'Year',
    eventTable: 'license_billed_event_tab (for the specified period)',
    notFound: 'License not found',
    search: 'Search',
    notification: 'License renewal operation started',
    tr: {
      id: 'ID',
      channel: 'Channel',
      price: 'Price',
      currency: 'Currency',
      paymentType: 'Payment type',
      periodStartedAt: 'Period started at',
      periodEndedAt: 'Period ended at',
      transactionId: 'Transaction ID',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      documentId: 'Document ID',
      tenantId: 'Tenant ID',
      subjectId: 'Sender ID',
      periodMonths: 'Period months ',
      name: 'Name',
      description: 'Description',
      licenseStatus: 'License status',
      activatedAt: 'Activated at',
      expiredAt: 'Expired at',
      cancelledAt: 'Cancelled at',
      activeUntil: 'Active until',
      paidUntil: 'Paid until',
      temporaryblockedAt: 'Temporary blocked at',
      paymentCode: 'Payment code',
    },
  },
  smsChannel: {
    subjectLabel: 'Enter the subject ID to find the profile.',
    notFound: 'There is no profile with such a Subject ID',
    searchResult: 'Search result',
    channelTable: {
      tenant: 'Tenant number',
      channelName: 'Channel name',
      subjectId: 'Subject_ID',
      status: 'Status',
    },
    channelInfo: {
      commonInfo: 'Channel info',
      name: 'Internal channel name:',
      tariff: 'Tariff:',
      subject: 'Sender name:',
      subscriptionsInfo: 'Operators and countries',
      operator: 'Operator',
      country: 'Country',
      subscription: 'Subscription type',
      operatorRus: '{{name}} Russia',
    },
    editSubscriptionsModal: {
      title: 'Change SMS subscriptions',
      submitButton: 'Save changes',
      operators: 'Russian operators',
      countries: 'Other countries',
      action: 'Select an action with an operator',
      selectOperator: 'Select operator',
      selectCountry: 'Select country',
      subscription: 'Subscription type',
      selectAll: 'Select all',
      smsCommon:
        '[en] Для тарифа {{name}} запрещено изменять набор операторов и типов трафика. Прежде чем продолжить, согласуйте действия с руководством.',
    },
    editSubscriptionsAction: {
      [`${ESubscriptionActionType.ADD}_${ESubscriptionCountryType.RUS}`]: 'Add operator',
      [`${ESubscriptionActionType.EDIT}_${ESubscriptionCountryType.RUS}`]:
        "Change operator's subscription",
      [`${ESubscriptionActionType.DELETE}_${ESubscriptionCountryType.RUS}`]: 'Delete operator',
      [`${ESubscriptionActionType.ADD}_${ESubscriptionCountryType.OTHERS}`]: 'Change country',
      [`${ESubscriptionActionType.DELETE}_${ESubscriptionCountryType.OTHERS}`]: 'Delete country',
    },
    successNotification: 'The SMS channel profile has been successfully changed',
  },
  tariffs: {
    title: 'Mass transfer of tariffs',
    channel: 'Channel',
    prevTariff: 'Current tariff',
    nextTariff: 'New tariff',
    tariffId: 'Tariff ID',
    licenseId: 'License ID',
    activeFrom: 'Date and time of tariff activation',
    coefficients: 'Transfer of coefficients',
    prevCoefficients: 'Leave as is',
    resetCoefficients: 'Reset to zero',
    successNotification: 'The change was successfully planned',
    confirmModal: {
      title: 'Are you sure? You are going to transfer tariffs en masse',
      check: 'Check the data:',
      id: 'ID',
      oldTariff: 'Current tariff',
      oldLicense: 'Current license',
      newTariff: 'New tariff:',
      newLicense: 'New license:',
      name: 'Name',
      channel: 'Channel',
      documentType: 'Document type',
      reseller: 'Reseller',
      version: 'Version',
      currency: 'Currency',
      country: 'Country',
      data: 'Properties',
    },
  },
  migration: {
    tabs: {
      [EMigrationTab.SUBJECTS]: 'Subjects',
      [EMigrationTab.PRISM]: 'Prism',
    },
    subjects: {
      title: '[en] Планирование миграции подписи',
      sourceTenantId: '[en] ID текущей тенанты',
      channelType: '[en] Тип канала',
      subjectId: '[en] Подпись',
      licenseId: '[en] Лицензия',
      targetTenantId: '[en] ID тенанты для переноса',
      availableTariffId: '[en] Шаблон тарифа',
      scheduledDate: '[en] Дата миграции',
      scheduledTime: '[en] Время миграции',
      migrateOperatorTemplates: '[en] Перенести/дублировать операторские шаблоны в новую тенанту',
      migrateJivoIntegration: '[en] Переключить интеграцию Jivo',
      migrateCallbackIntegration: 'Transfer webhook settings',
      migrateHpxIntegration: '[en] Переключить интеграцию eCC (HPX)',
      blockOldLicense: '[en] Заблокировать лицензию на старой тенанте',
      submitButton: '[en] Запланировать миграцию',
      successNotification: '[en] Миграция успешно запланирована',
      deleteSuccessNotification: '[en] Запрос на миграцию удалён',
      listTitle: '[en] Запланированные и выполненные миграции',
      deleteConfirmTitle: '[en] Удалить запрос на миграцию?',
      deleteConfirmButton: '[en] Удалить',
      cancelButton: '[en] Отмена',
      table: {
        id: '[en] ID',
        sourceTenantId: '[en] Источник',
        targetTenantId: '[en] Назначение',
        channelType: '[en] Канал',
        subjectId: '[en] Подпись',
        status: '[en] Статус',
        scheduledAt: '[en] Запланировано',
        createdAt: '[en] Создано',
        actions: '[en] Действия',
      },
      status: {
        [EMigrationStatus.PENDING]: '[en] Ожидает',
        [EMigrationStatus.IN_PROGRESS]: '[en] В процессе',
        [EMigrationStatus.COMPLETED]: '[en] Завершена',
        [EMigrationStatus.FAILED]: '[en] Ошибка',
      },
      selectPlaceholder: '[en] Выберите',
    },
    prism: {
      dataLabel: 'Вставьте тело запроса',
      successNotification: '[en] Миграция успешно запланирована',
      submitButton: '[en] Запланировать миграцию',
    },
  },
};
